import styled from 'styled-components';
import { Button, ModalBody, ModalContent, Typography } from '@web-chat-core/ui-kit';

export const ParticipantsLimitErrorModalBody = styled(ModalBody)`
    box-sizing: border-box;
    width: 600px;
    min-height: 358px;
    background: ${(props) => props.theme.root.colors.basicColors['6%']};
    padding: 36px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    overflow-x: hidden;
`;

export const ParticipantsLimitErrorModalContent = styled(ModalContent)`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const ParticipantsLimitErrorActions = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 36px;
`;

export const ParticipantsLimitErrorAction = styled(Button)`
    display: flex;
    align-items: center;
    font-size: 14px;
    padding-top: 8px;
    padding-bottom: 8px;
    height: 40px;
`;

export const ParticipantsLimitErrorSecondaryAction = styled(ParticipantsLimitErrorAction)`
    background: transparent;
    color: ${(props) => props.theme.root.button['primary'].background};

    &:hover {
        background: transparent;
        color: ${(props) => props.theme.root.button['primary'].hoverBackground};
    }
`;

export const ParticipantsLimitErrorLogo = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 32px;
`;

export const ParticipantsLimitErrorTitle = styled(Typography)`
    margin-bottom: 16px;
`;

export const ParticipantsLimitErrorDescription = styled(Typography)`
    color: ${(props) => props.theme.root.colors.basicColors['55%']};
    margin-bottom: 32px;
`;

export const Logo = styled.img`
    width: auto;
    height: 40px;
    user-select: none;
    -webkit-user-drag: none;
`;
